import {createSelector} from 'reselect'
import keyBy from 'lodash/keyBy.js'
import sortBy from 'lodash/sortBy.js'

import {setForm, updateForm, formsSelector} from '../store.js'
import {fetchAllAPI} from '../common/fetchAll.js'

export const API_KEYS = 'api_keys'

export function apiKeysSelector(state) {
  return formsSelector(state)[API_KEYS] || apiKeysSelector.default
}
apiKeysSelector.default = {}

export function apiKeySelector(state, {apiKeyID}) {
  return apiKeysSelector(state)[apiKeyID]
}

export const activeAPIKeysSortedByNameSelector = createSelector(
  apiKeysSelector,
  (apiKeys) =>
    sortBy(apiKeys, 'name').filter(({archive_date}) => !archive_date),
)

export function setAPIKeys(apiKeys) {
  setForm(API_KEYS, keyBy(apiKeys, 'id'))
}

export function setAPIKey(apiKey) {
  updateForm(API_KEYS, {[apiKey.id]: apiKey})
}

export async function getAPIKeys() {
  const apiKeys = await fetchAllAPI('/api_key/', 'api_key')

  setAPIKeys(apiKeys)
}
